import { AxiosResponse } from "axios";
import { APIClient } from "./axiosClient";
import { ResponseData } from "./types/_public";
const api = new APIClient();

const path = "/audition-applications";
const applicationApi = {
  getApplications(params: any): Promise<any> {
    const url = `${path}`;
    return api.get(url, params);
  },
  getSummary(params: any): Promise<any> {
    const url = `${path}/summary`;
    return api.get(url, params);
  },
  getDetails(id: any): Promise<any> {
    const url = `${path}/${id}`;
    return api.get(url);
  },
  updateDetail(id: any, body: any): any {
    const url = `${path}/${id}/status`;
    return api.put(url, body);
  },
};

export default applicationApi;
